import React, { useState } from 'react';

export default function LogsFilterPanel({ 
  filters, 
  onFiltersChange, 
  onApplyFilters, 
  onClearFilters,
  loading,
  filterOptions
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleFilterChange = (key, value) => {
    onFiltersChange(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const fallbackActionsOptions = [
    { value: '', label: 'Todas as ações' },
    { value: 'login_success', label: 'Login realizado' },
    { value: 'login_failed', label: 'Falha no login' },
    { value: 'logout', label: 'Logout realizado' },
    { value: 'create_adolescente', label: 'Adolescente criado' },
    { value: 'update_adolescente', label: 'Adolescente atualizado' },
    { value: 'create_movimentacao', label: 'Movimentação criada' },
    { value: 'update_movimentacao', label: 'Movimentação atualizada' },
    { value: 'finalizar_movimentacao', label: 'Movimentação finalizada' },
    { value: 'create_atendimento', label: 'Atendimento criado' },
    { value: 'update_atendimento', label: 'Atendimento atualizado' },
    { value: 'create_user', label: 'Usuário criado' },
    { value: 'update_user', label: 'Usuário atualizado' },
    { value: 'search_system_logs', label: 'Busca de logs do sistema' },
    { value: 'system_error', label: 'Erro do sistema' },
    { value: 'validation_error', label: 'Erro de validação' },
    { value: 'permission_denied', label: 'Acesso negado' }
  ];

  const fallbackEntityOptions = [
    { value: '', label: 'Todas as entidades' },
    { value: 'User', label: 'User' },
    { value: 'Adolescente', label: 'Adolescente' },
    { value: 'Movimentacao', label: 'Movimentacao' },
    { value: 'Atendimento', label: 'Atendimento' },
    { value: 'Authentication', label: 'Authentication' },
    { value: 'System', label: 'System' },
    { value: 'System_logs', label: 'System_logs' }
  ];

  const dynamicActions = Array.isArray(filterOptions?.actions) ? filterOptions.actions : [];
  const dynamicEntityTypes = Array.isArray(filterOptions?.entity_types) ? filterOptions.entity_types : [];

  const actionsOptions = dynamicActions.length > 0
    ? [{ value: '', label: 'Todas as ações' }, ...dynamicActions]
    : fallbackActionsOptions;

  const entityOptions = dynamicEntityTypes.length > 0
    ? [{ value: '', label: 'Todas as entidades' }, ...dynamicEntityTypes]
    : fallbackEntityOptions;

  return (
    <div className="card filter-panel mb-4">
      <div className="card-header">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="card-title mb-0">
            <i className="bi bi-funnel me-2"></i>
            Filtros de Busca
          </h5>
          <button
            className="btn btn-sm btn-outline-light"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <i className={`bi bi-chevron-${isExpanded ? 'up' : 'down'}`}></i>
          </button>
        </div>
      </div>
      
      <div className={`collapse ${isExpanded ? 'show' : ''}`}>
        <div className="card-body">
          <div className="row g-3">
            {/* Período */}
            <div className="col-md-6">
              <label className="form-label">Período</label>
              <div className="row g-2">
                <div className="col-6">
                  <input
                    type="date"
                    className="form-control"
                    value={filters.dateStart}
                    onChange={(e) => handleFilterChange('dateStart', e.target.value)}
                    placeholder="Data inicial"
                  />
                </div>
                <div className="col-6">
                  <input
                    type="date"
                    className="form-control"
                    value={filters.dateEnd}
                    onChange={(e) => handleFilterChange('dateEnd', e.target.value)}
                    placeholder="Data final"
                  />
                </div>
              </div>
            </div>

            {/* Busca por termo */}
            <div className="col-md-6">
              <label className="form-label">Buscar por</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nome do usuário, ação, IP..."
                  value={filters.searchTerm}
                  onChange={(e) => handleFilterChange('searchTerm', e.target.value)}
                />
              </div>
            </div>

            {/* Ação */}
            <div className="col-md-4">
              <label className="form-label">Ação</label>
              <select
                className="form-select"
                value={filters.action}
                onChange={(e) => handleFilterChange('action', e.target.value)}
              >
                {actionsOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Entidade */}
            <div className="col-md-4">
              <label className="form-label">Entidade</label>
              <select
                className="form-select"
                value={filters.entityType}
                onChange={(e) => handleFilterChange('entityType', e.target.value)}
              >
                {entityOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            {/* IP */}
            <div className="col-md-4">
              <label className="form-label">Endereço IP</label>
              <input
                type="text"
                className="form-control"
                placeholder="Ex: 192.168.1.1"
                value={filters.ipAddress}
                onChange={(e) => handleFilterChange('ipAddress', e.target.value)}
              />
            </div>

            {/* ID do Usuário */}
            <div className="col-md-6">
              <label className="form-label">ID do Usuário</label>
              <input
                type="number"
                className="form-control"
                placeholder="ID numérico do usuário"
                value={filters.userId}
                onChange={(e) => handleFilterChange('userId', e.target.value)}
              />
            </div>

            {/* Filtros rápidos */}
            <div className="col-md-6">
              <label className="form-label">Filtros Rápidos</label>
              <div className="d-flex gap-3">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="showErrors"
                    checked={filters.showErrors}
                    onChange={(e) => handleFilterChange('showErrors', e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="showErrors">
                    Apenas erros
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="showCritical"
                    checked={filters.showCritical}
                    onChange={(e) => handleFilterChange('showCritical', e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="showCritical">
                    Apenas críticos
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* Botões de ação */}
          <div className="row mt-3">
            <div className="col-12">
              <div className="d-flex gap-2">
                <button
                  className="btn btn-success"
                  onClick={onApplyFilters}
                  disabled={loading}
                >
                  <i className="bi bi-search me-2"></i>
                  {loading ? 'Filtrando...' : 'Aplicar Filtros'}
                </button>
                <button
                  className="btn btn-outline-secondary"
                  onClick={onClearFilters}
                  disabled={loading}
                >
                  <i className="bi bi-arrow-counterclockwise me-2"></i>
                  Limpar
                </button>
                <div className="ms-auto">
                  <button
                    className="btn btn-outline-info btn-sm"
                    onClick={() => setIsExpanded(false)}
                  >
                    <i className="bi bi-chevron-up me-1"></i>
                    Recolher
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .filter-panel {
          background: rgba(18, 26, 23, 0.8);
          border: 1px solid rgba(132, 169, 140, 0.15);
          border-radius: 12px;
        }
        
        .filter-panel .card-header {
          background: rgba(132, 169, 140, 0.1);
          border-bottom: 1px solid rgba(132, 169, 140, 0.15);
          padding: 1rem;
        }
        
        .filter-panel .card-title {
          color: #84a98c;
          font-weight: 600;
        }
        
        .filter-panel .form-label {
          color: rgba(255, 255, 255, 0.8);
          font-weight: 500;
          margin-bottom: 0.5rem;
        }
        
        .filter-panel .form-control,
        .filter-panel .form-select {
          background: rgba(13, 18, 16, 0.8);
          border: 1px solid rgba(132, 169, 140, 0.2);
          color: #ffffff;
        }
        
        .filter-panel .form-control:focus,
        .filter-panel .form-select:focus {
          background: rgba(13, 18, 16, 0.9);
          border-color: #84a98c;
          box-shadow: 0 0 0 0.2rem rgba(132, 169, 140, 0.25);
          color: #ffffff;
        }
        
        .filter-panel .form-control::placeholder {
          color: rgba(255, 255, 255, 0.5);
        }
        
        .filter-panel .form-select option {
          background: #1a1a1a;
          color: #ffffff;
        }
        
        .filter-panel .input-group-text {
          background: rgba(132, 169, 140, 0.1);
          border: 1px solid rgba(132, 169, 140, 0.2);
          color: #84a98c;
        }
        
        .filter-panel .form-check-input {
          background-color: rgba(132, 169, 140, 0.1);
          border-color: rgba(132, 169, 140, 0.3);
        }
        
        .filter-panel .form-check-input:checked {
          background-color: #84a98c;
          border-color: #84a98c;
        }
        
        .filter-panel .form-check-label {
          color: rgba(255, 255, 255, 0.8);
        }
        
        .btn-success {
          background-color: #84a98c;
          border-color: #84a98c;
        }
        
        .btn-success:hover {
          background-color: #6f8770;
          border-color: #6f8770;
        }
        
        .btn-success:disabled {
          background-color: #6f8770;
          border-color: #6f8770;
          opacity: 0.6;
        }
        
        .collapse {
          transition: height 0.35s ease;
        }
      `}</style>
    </div>
  );
}
